/**
 * Haptic feedback for the warehouse PWA.
 *
 * Android Chrome supports `navigator.vibrate` directly; the standalone
 * iOS PWA inherits Safari's quiet ignore of the API, so on iPhone these
 * are no-ops. That's fine — the operator still gets the visual flash
 * + toast. Where supported, the buzz makes a successful scan obvious
 * with the phone face-down on the packing bench.
 *
 * Wrapped in a try / catch + capability check because some embedded
 * browsers throw rather than ignore.
 */

function vibrate(pattern: number | number[]): void {
  try {
    if (typeof navigator !== 'undefined' && typeof navigator.vibrate === 'function') {
      navigator.vibrate(pattern);
    }
  } catch {
    /* non-fatal */
  }
}

export const haptics = {
  /** A single short tap — successful scan / button confirm. */
  tap: () => vibrate(15),
  /** Two quick pulses — a state transition completed (e.g. line full). */
  success: () => vibrate([15, 60, 15]),
  /** Longer pulse — error / refusal (broken seal, scan rejected). */
  warn: () => vibrate(120),
};
